import _ from 'lodash';
import { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { PEXBDFormStepContent } from '../components/StyledComponents';
import FormSection from '../sections/FormSection';
import { useFormSpecRegistry } from '../models/FormSpecRegistryContext';

const GeneratedFormStep: React.FC<{path:string, spec: any }> = ({ path, spec }) => {
  const stepSpec = _.get(spec, path);
  const registry = useFormSpecRegistry();
  const topOfSectionRef = useRef<null | HTMLDivElement>(null);

  useEffect(() => {
    if (topOfSectionRef.current) {
      topOfSectionRef.current.scrollIntoView({ block: 'start' });
    }
  }, [topOfSectionRef, stepSpec]);

  return (
    <PEXBDFormStepContent>
      <Box ref={topOfSectionRef} sx={{ height: '40px', width: '100%' }}></Box>
      {stepSpec && stepSpec.questions.map((question:any, index: number) => <Box key={question.id ?? index}>
        <FormSection
          question={question}
          sectionPath={`${path}.questions`}
          fieldPath={registry.getQuestionPath(question.id)}
        />
      </Box>)}
    </PEXBDFormStepContent>
  );
};

export default GeneratedFormStep;
